<template>
    <main class="pd-main pb-100">
        <div class="main-content">
            <header class="header no-border">
                <div class="header-bar">
                <h4 class="text-uppercase">All Chats</h4>
                </div>
            </header>
            <div class="card card-body no-border">
                    <strong>ATTENTION: Always ensure to logout from your listener account whenever you leave Fitila. You don't want to leave members who need your help hanging!</strong>
                </div>
            <circle-spin class="m-0" v-if="firstLoad"></circle-spin>
            <div class="card" v-else>
                <no-training v-if="!active_training"></no-training>
                <div class="card-body p-50 text-center" v-if="active_training && !all_chats">
                    <div class="pb-10">
                      <i class="ion-chatboxes fs-svg"></i>
                    </div>
                    <div class="mb-10" >
                       <h5> Welcome to Chat Room! </h5>
                        <strong>No Member has started a chat with you.</strong>
                    </div>
                </div>
                <div class="card-body p-0 row no-margin" v-if="active_training && all_chats">
                    <div class="col-md-3 p-0 br-1 br-primary">
                        <h5 class="card-title text-uppercase"><strong>Active Chats</strong></h5>
                        <!-- for bigger screens -->
                        <div class="chat-sm-hidden scroll h-default media-striped media-list media-list-divided media-list-hover">
                           <div class="media-list-body">
                               <div class="bb-1 media align-items-center" v-for="discussion in all_discussions" :key="discussion.id" @click="openChat(discussion)">
                                   <a class="flexbox align-items-center flex-grow gap-items" href="#" >
                                        <img class="avatar" v-if="discussion.seekers[0].avatars[0].secure_url == null" src="../../assets/static/img/avatar.jpg" alt="image" >
                                        <img class="avatar" v-else :src="discussion.seekers[0].avatars[0].secure_url" alt="image" >
                                        <div class="media-body text-truncate">
                                            <h6>{{discussion.seekers[0].Users[0].nickname}}</h6>
                                        </div>
                                    </a> 
                               </div>
                           </div>
                        </div>
                        <!-- for mobile -->
                        <div :class="chat_list?'chat-sm-visible':'chat-sm-hidden'" class="chat-md-hidden scroll h-default media-striped media-list media-list-divided media-list-hover">
                           <div class="media-list-body">
                               <div class="bb-1 media align-items-center" v-for="discussion in all_discussions" :key="discussion.id" @click="openChatMobile(discussion)">
                                   <a class="flexbox align-items-center flex-grow gap-items" href="#" >
                                        <img class="avatar" v-if="discussion.seekers[0].avatars[0].secure_url == null" src="../../assets/static/img/avatar.jpg" alt="image" >
                                        <img class="avatar" v-else :src="discussion.seekers[0].avatars[0].secure_url" alt="image" >
                                        <div class="media-body text-truncate">
                                            <h6>{{discussion.seekers[0].Users[0].nickname}}</h6>
                                        </div>
                                    </a> 
                               </div>
                           </div>
                        </div>
                    </div>
                    <div class="chat-sm-hidden col-md-9 p-10" v-if="!open_chat">
                        <div class="card-body p-50 text-center">
                            <div class="pb-10">
                                <i class="ion-chatboxes fs-svg"></i>
                            </div>
                            <div class="mb-10" >
                                <h5> Welcome to Chat Room! </h5>
                                <strong>Click on a member to view the chat</strong>
                            </div>
                        </div>
                    </div>
                    <div v-else class="col-sm-12 col-md-9 p-0">
                        <!-- for bigger screens -->
                        <div class="chat-sm-hidden mb-60">
                            <header class="flexbox align-items-center p-10 pr-20 bg-lighter bb-1 border-light">
                                <div class="media align-items-center p-0">
                                    <a href="#">
                                        <img class="avatar" v-if="seeker_img == ''" src="../../assets/static/img/avatar.jpg" alt="...">
                                        <img class="avatar" v-else :src="seeker_img" alt="...">
                                    </a>
                                    <div class="media-body">
                                        <h6><a href="#">{{seeker_name}}</a></h6>
                                    </div>
                                </div>
                                <div class="dropdown">
                                    <a class="text-lighter" data-toggle="dropdown" href="#"><i class="ion-android-more-vertical"></i></a>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item" :href="mailFitila"><i class="ion-ios-close"></i> Report Member</a>
                                    </div>
                                </div>
                            </header>
                            <!-- chat content  -->
                            <bounce class="m-0 h-default" v-if="loading"></bounce>
                            <div class="flex-grow h-default" v-else>
                                <div v-if="!no_messages" id="chat" class="h-default scroll">
                                    <div class="media media-chat" 
                                    :class="all_messages.usertype == 'listener' ? 'media-chat-reverse':null">
                                        <div class="media-body">
                                            <p>{{all_messages.text}}</p>
                                        </div>
                                    </div>
                                    <div v-if="responses.length> 0">
                                        <div class="media media-chat" v-for="response in responses" :key="response.id"
                                        :class="response.usertype == 'listener' ? 'media-chat-reverse':null">
                                            <div class="media-body">
                                                <p>{{response.text}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="media media-chat" v-for="response in all_messages.responses" :key="response.id"
                                        :class="response.usertype == 'listener' ? 'media-chat-reverse':null">
                                            <div class="media-body">
                                                <p>{{response.text}}</p>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                            <footer class="publisher">
                                <input v-model="message" class="publisher-input" placeholder="Write something">
                                <div class="align-self-end gap-items">
                                    <a class="publisher-btn"  @click="sendMessage"><i class="ion-ios-paperplane"></i></a>
                                </div>
                            </footer>
                        </div>
                        <!-- for mobile -->
                        <div :class="chat_list?'chat-sm-hidden':'chat-sm-visible'" class="chat-md-hidden mb-60">
                            <header class="flexbox align-items-center p-10 pr-20 bg-lighter bb-1 border-light">
                                <div class="media align-items-center p-0">
                                    <a href="#" @click="goToChatList">
                                        <i class="ion-arrow-left-c"></i>
                                    </a>
                                    <a href="#">
                                        <img class="avatar" v-if="seeker_img == ''" src="../../assets/static/img/avatar.jpg" alt="...">
                                        <img class="avatar" v-else :src="seeker_img" alt="...">
                                    </a>
                                    <div class="media-body">
                                        <h6><a href="#">{{seeker_name}}</a></h6>
                                    </div>
                                </div>
                                <div class="dropdown">
                                    <a class="text-lighter" data-toggle="dropdown" href="#"><i class="ion-android-more-vertical"></i></a>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <a class="dropdown-item " :href="mailFitila"><i class="ion-ios-close"></i> Report Member</a>
                                    </div>
                                </div>
                            </header>
                            <!-- chat content  -->
                            <bounce class="m-0 h-default" v-if="loading"></bounce>
                            <div class="flex-grow h-default" v-else>
                                <div v-if="!no_messages" id="chat-mobile" class="h-default scroll">
                                    <div class="media media-chat" 
                                    :class="all_messages.usertype == 'listener' ? 'media-chat-reverse':null">
                                        <div class="media-body">
                                            <p>{{all_messages.text}}</p>
                                        </div>
                                    </div>
                                    <div v-if="responses.length> 0">
                                        <div class="media media-chat" v-for="response in responses" :key="response.id"
                                        :class="response.usertype == 'listener' ? 'media-chat-reverse':null">
                                            <div class="media-body">
                                                <p>{{response.text}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="media media-chat" v-for="response in all_messages.responses" :key="response.id"
                                        :class="response.usertype == 'listener' ? 'media-chat-reverse':null">
                                            <div class="media-body">
                                                <p>{{response.text}}</p>
                                            </div>
                                        </div>
                                    </div>   
                                        
                                </div>
                            </div>
                            <footer class="publisher">
                                <input v-model="message" class="publisher-input" placeholder="Write something">
                                <div class="align-self-end gap-items">
                                    <a class="publisher-btn"  @click="sendMessage"><i class="ion-ios-paperplane"></i></a>
                                </div>
                            </footer>
                        </div>
                        
                    </div>      
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import axios from 'axios'
import noTraining from '../../components/user/NoTraining.vue'
import allMixins from '../../mixins.js'
// import io from 'socket.io-client';

export default {
    name: "chatListener",
    mixins: [allMixins],
    data() {
        return {
             mode: "",
            title: "",
            firstLoad: false,
            loading: false,
            load_send: false,
            listener_id: null,
            all_chats: false,
            open_chat: false,
            columns: ["name"],
            all_discussions: [],
            current_discussion_id: null,
            all_messages: {},
            no_messages: true,
            responses: [],
            main_message_id: null,
            message: '',
            seeker_name: '',
            seeker_img: '',
            seeker_id: null,
            seeker_user_id: null,
            active_training: null,
            chat_list: true,
            // socket : io('https://mcfapi.herokuapp.com')
        }
    },
     watch: {
        all_messages:{
            handler: function() {
            this.$nextTick(function() {
                var divs = document.getElementById('chat')
                var div_mobile = document.getElementById('chat-mobile')
                    divs.scrollTop = divs.scrollHeight
                    div_mobile.scrollTop = div_mobile.scrollHeight
            }) },
            deep: true
        },
        responses: {
            handler: function() {
            this.$nextTick(function() {
                var divs = document.getElementById('chat')
                var div_mobile = document.getElementById('chat-mobile')
                    divs.scrollTop = divs.scrollHeight
                    div_mobile.scrollTop = div_mobile.scrollHeight
            }) },
            deep: true
        }
    },
    computed: {
        mailFitila() {
            return `mailto:hello@mentalcare.life?subject=Report%20Fitila%20Member%20with%20Nickname%20${this.seeker_name}`
        }
    },

    methods: {
        goToChatList() {
            this.chat_list = true
        },
        openChatMobile(payload) {
            this.chat_list = false 
            this.openChat(payload)
        },
        openChat(payload) {
            this.seeker_name = `${payload.seekers[0].Users[0].nickname}`
            this.seeker_img = payload.seekers[0].avatars[0].secure_url
            this.seeker_user_id = payload.seekers[0].Users[0].id
            this.seeker_id = payload.seekers[0].id
            this.current_discussion_id = payload.id
            this.open_chat = true
            this.loading = true
            axios.get(`/users/discussion/one?id=${this.current_discussion_id}&listenerId=${this.listener_id}`)
            .then(res => {
                this.loading = false
                if(res.data.discussion.messages.length > 0){
                    this.no_messages = false
                    this.all_messages = res.data.discussion.messages[0]
                    this.main_message_id = this.all_messages.id
                }
                else {this.no_messages = true }
            })
            .catch(err => {
                this.loading = false
                this.$notify({
                    group: 'response',
                    type: 'error',
                    text:  `${err.response.data.message}`,
                    duration: 5000
                })
            })
            
        },
        reloadChat() {
            // this.loading = true
            this.load_send = true
            axios.get(`/users/discussion/one?id=${this.current_discussion_id}&listenerId=${this.listener_id}`)
            .then(res => {
                // this.loading = false
                this.load_send = false
                    this.no_messages = false
                    this.all_messages = res.data.discussion.messages[0]
                    this.main_message_id = this.all_messages.id
            })
            .catch(err => {
                // this.loading = false
                this.load_send = false
                this.$notify({
                    group: 'response',
                    type: 'error',
                    text:  `${err.response.data.message}`,
                    duration: 5000
                })
            })
        },
        sendMessage() {
            if(this.no_messages == true) {
                let userData = {
                    discussionId: this.current_discussion_id,
                    text: this.message,
                    senderId: this.listener_id,
                    usertype: "listener"
                }
                this.$socket.emit('new_message', userData, data => {
                    // console.log(data)
                })
                this.message= ''
            }
            else {
                let userData = {
                    messageId: this.main_message_id,
                    text: this.message,
                    senderId: this.listener_id,
                    usertype: "listener"
                }
                this.$socket.emit('message_reply', userData, data => {
                    // console.log(data)
                })
                this.message = ''
            }
        },
    },
    mounted() { 
        this.firstLoad = true
        let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")
        axios.get(`users/find/${details.id}`)
        .then(res => {
            this.listener_id = res.data.listener[0].id
            this.active_training= res.data.listener[0].trainings.some(training => training.title == "Active Listening")

            // Get all discussions for the current user, return seekers details with discussionIds
                axios.get(`/users/discussion/all/user/active?m=listener&listenerId=${this.listener_id}`) // Confirm 
                .then(res => {
                    this.all_discussions= res.data.discussions
                    if(this.all_discussions.length > 0){
                        this.all_chats = true
                        this.firstLoad = false
                    }
                    else {
                        this.all_chats = false
                        this.firstLoad = false
                    }
                })
                .catch(err => {
                    this.firstLoad = false
                    this.$notify({
                            group: 'response',
                            type: 'error',
                            text:  `${err.response.data.message}`,
                            duration: 5000
                    })
                })
        })
        .catch(err => {
            this.firstLoad = false
                this.$notify({
                        group: 'response',
                        type: 'error',
                        text:  `${err.response.data.message}`,
                        duration: 5000
                })
        })       
    },
    sockets: {
        message_pop: function(val){
            this.all_messages = val;
            this.main_message_id = val.id
            this.no_messages = false
        },
        response_pop: function(val){
            if(!this.all_messages.responses){
                this.responses.push(val)
            }
            else {
               this.all_messages.responses.push(val);
            }
        }
    },
    components: {
        noTraining
    }
}
</script>
